import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Layers from "slotworks/graphics/layers/layers";
import { wrapIndex } from "slotworks/utils/collection-utils";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";

export default class ReelComponent {

    public readonly index: number;
    public readonly size: number;

    public mask: PIXI.Sprite | PIXI.Graphics;
    public validLandSymbols: string[];

    private stopIndex: number;

    private symbols: SymbolComponent[];

    constructor(index: number, rows: number, reelstrip: string[], defaultStop: number = 0) {
        this.index = index;
        this.size = rows;

        this.symbols = [];

        for (let row = 1; row < rows + 1; row++) {
            const symbol = new SymbolComponent(new Point(index, row));

            this.symbols.push(symbol);
        }

        this.resetSymbolPositions();
        this.jump(defaultStop, reelstrip);
    }

    /**
     * Reset symbol positions to default positionRects defined in assetworks (symbol_x_y)
     */
    public resetSymbolPositions() {
        for (const symbol of this.symbols) {
            let positionRect;

            if (this.mask) {
                symbol.setMask(this.mask);
            }

            const x = symbol.gridPosition.x;
            const y = symbol.gridPosition.y;

            positionRect = Layers.MatrixContent.getPosition(`symbol_${x}_${y}`);

            symbol.setTransform(positionRect);
        }
    }

    public jump(index: number, reelstrip: string[]) {
        this.stopIndex = index;

        for (let i = 0; i < this.symbols.length; i++) {

            const symbol = this.symbols[i];
            const offsetIndex = this.stopIndex + i;

            const symbolId = wrapIndex(offsetIndex, reelstrip);

            symbol.setSymbol(symbolId);
        }
    }

    public spin() {
        for (const symbol of this.symbols) {
            symbol.setMoving(true);
        }
        return Contract.empty();
    }

    public land() {
        for (const symbol of this.symbols) {
            symbol.setMoving(false);
        }
        return Contract.empty();
    }

    public getSymbols() {
        return this.symbols;
    }

    public getSymbolAt(y: number) {
        return this.symbols[y];
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/reel/reel-component.ts